import React, { useEffect, useState, useMemo } from 'react'
import { equals } from 'ramda'

import { Selectors } from '@react-page/core/lib'

import DragDropProvider from '@react-page/core/lib/components/DragDropProvider'
import HotKeyDecorator from '@react-page/core/lib/components/HotKey/Decorator'
import Inner from '@react-page/core/lib/components/Editable/Inner'
import { ReduxProvider } from '@react-page/core/lib/reduxConnect'

import BlurGate from './BlurGate'
import Trash from '../Trash'

const Editable = ({ id, editor, onChange }) => {
    const { store, defaultPlugin } = editor

    const [unsubscribe, setUnsubscribe] = useState()
    const [previousState, setPreviousState] = useState()
    const [previousSerialized, setPreviousSerialized] = useState()

    useEffect(() => {
        setUnsubscribe(
            store.subscribe(() => {
                if (typeof onChange !== 'function') {
                    return
                }

                const state = Selectors.Editable.editable(store.getState(), { id })

                // prevent uneeded updates
                const isEqual = equals(state, previousState)

                if (!state || isEqual) {
                    return
                }

                setPreviousState(state)

                const serialized = editor.plugins.serialize(state)
                const serializedEqual = equals(previousSerialized, serialized)

                if (serializedEqual) {
                    return
                }

                setPreviousSerialized(serialized)
                onChange(serialized)
            })
        )

        return () => {
            if (unsubscribe) {
                unsubscribe()
            }
        }
    }, [])

    return useMemo(() => (
        <ReduxProvider store={store}>
            <DragDropProvider>
                <HotKeyDecorator id={id}>
                    <BlurGate>
                        <Inner id={id} defaultPlugin={defaultPlugin} />
                        <Trash editor={editor} />
                    </BlurGate>
                </HotKeyDecorator>
            </DragDropProvider>
        </ReduxProvider>
    ))
}

export default Editable
